<template>
  <div class="order">

    <!-- Split into two kinds of cards (single product / multiple products) -->
    <!-- After that we'll split multiple products one into moble/desktop -->

    <SingleOrder :prod="prod" v-if="orderType == 'single'"/>
    <MultipleOrders :prod="prod" v-else />

<!--     <ul class="products">
      <li class="desc">#1 Of kind</li> -->

      <!-- Will be able to check out which products do you want to see/try: -->
      <!-- <li v-for="product in products">{{ product }}</li> -->
    <!-- </ul> -->
<!--
    <form v-on:submit.prevent="onSubmit">
      <label for="name_surname">Name Surname:</label>
      <input id="name_surname" type="text" name="name_surname">

      <label for="email">E-Mail:</label>
      <input id="email" type="email" name="email">

      <input type="submit" value="Send">
    </form> -->

  </div>
</template>

<script>

import SingleOrder from './SingleOrder';
import MultipleOrders from './MultipleOrders';


export default {
  name: 'OrderCard',
  props: {
    orderType: String,
    prod: [Object, Array],
  },
  components: {
    SingleOrder,
    MultipleOrders,
  },
  methods: {
    onSubmit: function(e) {
      console.log('Submitting a form with products');
      console.log(e);
    },
  }
};
</script>

<style scoped lang="stylus">

@import '../styles/common.styl'

.order
  position fixed
  width 100%
  max-width 1000px
  max-height 680px
  left 0px
  top 0px
  top 0vh
  bottom 0px
  right 0px
  margin auto
  background-color $OTSbg
  z-index 5
  border-radius 4px
  box-shadow 0px 0px 1000px 1000px rgba($OTSnavBlue, 0.9)
  overflow auto

</style>



// WEBPACK FOOTER //
// src/components/OrderCard.vue